<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >

    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="list-users-actions-enableUser-activator">
        <slot></slot>
      </div>
    </template>

    <v-form
      ref="form"
      v-on:submit.prevent="savePermissions"
      autocomplete="off"
      v-bind:disabled="isFormDisabled"
      data-cy="dialog-setPermissions-form"
    >

      <v-card v-cloak data-cy="dialog-setPermissions-modal">

        <v-card-title class="d-flex justify-space-between mb-2" data-cy="dialog-setPermissions-title">
          {{ $t("menus.userPermissions.setUserPermissions") }}

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text ref="cardBody" scrollable class="scrollable" data-cy="dialog------">
          <div v-if="!getEditUser" class="bg-error">
            {{ $t("menus.createUser.userNotSelected") }}
          </div>
          <div v-else data-cy="dialog-setPermissions-userDetails">

            <v-row>
              <v-col cols=12>
                <v-alert
                  density="compact"
                >
                  {{ accessPointName }}
                </v-alert>
              </v-col>
            </v-row>

          </div>

          <v-row v-if="canShowUserPermissions">
            <v-col cols=12 sm=6 offset-sm=3>

              <v-list-subheader>
                <h3>
                  {{ $t("menus.userPermissions.userManagement") }}
                </h3>
              </v-list-subheader>

              <div data-cy="dialog-setPermissions-listUsers" v-if="$canListUser()">
                <v-switch
                  style="margin-top: 0"
                  v-model="userList"
                  v-bind:label="$t('menus.userPermissions.listUsers')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div data-cy="dialog-setPermissions-manageUsers" v-if="$canControlUser()">
                <v-switch
                  style="margin-top: 0"
                  v-model="userControl"
                  v-bind:label="$t('menus.userPermissions.manageUsers')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div v-if="isContextUserIsTeamMember">
                <div data-cy="dialog-setPermissions-controlTenantConfig"
                     v-if="$canControlTenantConfig()">
                  <v-switch
                    style="margin-top: 0"
                    v-model="tenantconfigControl"
                    v-bind:label="$t('menus.userPermissions.controlTenantConfig')"
                    hide-details
                    density="compact"
                    color="primary"
                    block
                  />
                </div>

                <div data-cy="dialog-setPermissions-belongsToTeam"
                     v-if="$canControlUser()">
                  <v-switch
                    style="margin-top: 0"
                    v-model="belongsToTeam"
                    v-bind:label="$t('menus.userPermissions.belongsToTeam')"
                    hide-details
                    density="compact"
                    color="primary"
                    block
                  />
                </div>

                <div data-cy="dialog-setPermissions-purchaseResources"
                     v-if="$canPurchaseResources() && isEditUserRootNodeTeamMember && canEditUserControlTenantConfig">
                  <v-switch
                    style="margin-top: 0"
                    v-model="purchaseResources"
                    :label="$t('menus.userPermissions.purchaseResources')"
                    hide-details
                    density="compact"
                    color="primary"
                    block
                  />
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols=12 sm=6 offset-sm=3>
              <v-list-subheader>
                <h3>
                  {{ $t("menus.userPermissions.nodesAndPods") }}
                </h3>
              </v-list-subheader>

              <div data-cy="dialog-setPermissions-listNodesAndPods" v-if="$canListNodeAndPod()">
                <v-switch
                  style="margin-top: 0"
                  v-model="nodeandpodList"
                  v-bind:label="$t('menus.userPermissions.listNodesAndPods')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div data-cy="dialog-setPermissions-controlNodesAndPods" v-if="$canControlNodeAndPod()">
                <v-switch
                  style="margin-top: 0"
                  v-model="nodeandpodControl"
                  v-bind:label="$t('menus.userPermissions.controlNodesAndPods')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div data-cy="dialog-setPermissions-deleteNodesAndPods" v-if="$canDeleteNodeAndPod()">
                <v-switch
                  style="margin-top: 0;"
                  v-model="nodeandpodDelete"
                  v-bind:label="$t('menus.userPermissions.deleteNodesAndPods')"
                  hide-details block
                  color="primary"
                  density="compact">
                </v-switch>
              </div>


              <div data-cy="dialog-setPermissions-downloadNodesAndPods" v-if="$canDownloadNodeAndPod()">
                <v-switch
                  style="margin-top: 0"
                  v-model="nodeandpodDownload"
                  v-bind:label="$t('menus.userPermissions.downloadNodesAndPods')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div data-cy="dialog-setPermissions-showPodAssets" v-if="$canListAsset()">
                <v-switch
                  style="margin-top: 0"
                  v-model="assetList"
                  v-bind:label="$t('menus.userPermissions.showPodAssets')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div data-cy="dialog-setPermissions-uploadFilesAndAssets" v-if="$canUploadFileAndAsset()">
                <v-switch
                  style="margin-top: 0"
                  v-model="fileandassetUpload"
                  v-bind:label="$t('menus.userPermissions.uploadFilesAndAssets')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div data-cy="dialog-setPermissions-listShareLinks" v-if="$canListShareLinks()">
                <v-switch
                    style="margin-top: 0"
                    v-model="listShareLinks"
                    v-bind:label="$t('menus.userPermissions.listShareLinks')"
                    hide-details
                    density="compact"
                    color="primary"
                    block
                />
              </div>

              <div data-cy="dialog-setPermissions-controlShareLinks" v-if="$canControlShareLinks()">
                <v-switch
                  style="margin-top: 0"
                  v-model="controlShareLinks"
                  v-bind:label="$t('menus.userPermissions.controlShareLinks')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div data-cy="dialog-setPermissions-archiveNodesAndPods"
                   v-if="isContextUserIsTeamMember && $canArchiveNodeAndPod()">
                <v-switch
                  style="margin-top: 0"
                  v-model="nodeandpodArchive"
                  v-bind:label="$t('menus.userPermissions.archiveNodesAndPods')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

              <div data-cy="dialog-setPermissions-viewAnalyticsNodeAndPods" v-if="$canViewPodAndNodeAnalytics()">
                <v-switch
                  style="margin-top: 0"
                  v-model="viewAnalytics"
                  :label="$t('menus.userPermissions.viewAnalytics')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>
              <div data-cy="dialog-setPermissions-labelPods" v-if="$canLabelPods()">
                <v-switch
                  style="margin-top: 0"
                  v-model="podsLabel"
                  :label="$t('menus.userPermissions.labelPods')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols=12 sm=6 offset-sm=3>
              <v-list-subheader>
                <h3>
                  {{$t('menus.userPermissions.services')}}
                </h3>
              </v-list-subheader>

              <div data-cy="dialog-setPermissions-listPodServices" v-if="$canListPodService()">
                <v-switch
                  style="margin-top: 0"
                  v-model="podserviceList"
                  v-bind:label="$t('menus.userPermissions.listPodServices')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                >
                </v-switch>
              </div>

              <div data-cy="dialog-setPermissions-controlPodServices" v-if="$canControlPodService()">
                <v-switch
                  style="margin-top: 0"
                  v-model="podserviceControl"
                  v-bind:label="$t('menus.userPermissions.controlPodServices')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                >
                </v-switch>
              </div>

              <div data-cy="dialog-setPermissions-useFreeServices" v-if="$canRunFreeService()">
                <v-switch
                  style="margin-top: 0"
                  v-model="useFreeServices"
                  v-bind:label="$t('menus.userPermissions.useFreeServices')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                >
                </v-switch>
              </div>

              <div data-cy="dialog-setPermissions-usePaidServices" v-if="isContextUserIsTeamMember && $canRunPaidService()">
                <v-switch
                  style="margin-top: 0"
                  v-model="usePaidServices"
                  v-bind:label="$t('menus.userPermissions.usePaidServices')"
                  hide-details
                  density="compact"
                  color="primary"
                  block
                />
              </div>

            </v-col>
          </v-row>


          <div v-if="apiError" class="bg-error mt-2">{{apiError}}</div>
          <div v-if="isCurrentUser" class="bg-error mt-2" data-cy="dialog-setPermissions-apiErrorSelf">{{$t('menus.userPermissions.cannotChangerOwnPermissions')}}</div>
          <div v-if="successMessage" class="bg-success mt-2">{{successMessage}}</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            v-bind:disabled="isFormDisabled"
            class="bg-primary"
            elevation=0
            data-cy="dialog-setPermissions-button"
          >
            {{ $t("menus.userPermissions.setPermissions") }}
          </v-btn>

          <v-btn variant="text" @click="closeDialog" data-cy="dialog-enableSelectedUsers-false">
            {{$t('common.cancel')}}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useUserStore } from '@/stores/UserStore.js'
import { useNodeStore } from '@/stores/NodeStore.js';
import { useCommonStore } from '@/stores/CommonStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  mixins: [DialogActionKeys],
  name: "UserPermissionsDialog",
  props: {
    getEditUser: {
      type: Object,
      required: false,
    },
    accessPointId: {
      type: String,
      required: false,
    },
  },
  data: function() {
    return {
      dialog: false,

      apiError: "",
      successMessage: "",

      userList: false,
      userControl: false,
      tenantconfigControl: false,
      belongsToTeam: false,
      purchaseResources: false,

      nodeandpodList: true,
      nodeandpodControl: true,
      nodeandpodDelete: true,
      nodeandpodDownload: true,
      podsLabel: false,
      assetList: true,
      fileandassetUpload: true,
      nodeandpodArchive: false,
      listShareLinks: true,
      controlShareLinks: true,
      viewAnalytics: true,

      podserviceList: true,
      podserviceControl: true,
      useFreeServices: false,
      usePaidServices: false,

      preventDoubleClick: false,
      userCreated: false,
    }
  },
  mounted() {
    this.updateControls(this.getEditUser);
  },
  watch: {
    dialog() {
      this.apiError = "";
      this.updateControls(this.getEditUser);
    },
    controlShareLinks: function (newValue) {
      if (newValue) {
        this.listShareLinks = true;
      }
    },
    belongsToTeam: function (newValue) {
      if (!newValue) {
        this.purchaseResources = false;
      }
    },
    tenantconfigControl: function (newValue) {
      if (!newValue) {
        this.purchaseResources = false;
      }
    }
  },
  methods: {
    savePermissions: async function () {
      this.apiError = "";
      this.successMessage = "";

      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.preventDoubleClick = true;

      const formData = {
        'NodeAndPod.list': this.nodeandpodList,
        'NodeAndPod.control': this.nodeandpodControl,
        'NodeAndPod.download': this.nodeandpodDownload,
        'NodeAndPod.delete': this.nodeandpodDelete,
        'NodeAndPod.viewAnalytics': this.viewAnalytics,

        'Pod.label': this.podsLabel,
        'Asset.list': this.assetList,
        'FileAndAsset.upload': this.fileandassetUpload,

        'PodService.list': this.podserviceList,
        'PodService.control': this.podserviceControl,
        'FreeService.run': this.useFreeServices,
        'ShareLinks.control': this.controlShareLinks,
        'ShareLinks.list': this.listShareLinks,
      };

      if (this.canShowUserPermissions) {
        formData['User.list'] = this.userList;
        formData['User.control'] = this.userControl;
      }

      if (this.isContextUserIsTeamMember) {
        formData['TenantConfiguration.control'] = this.tenantconfigControl;
        formData['TenantConfiguration.purchaseResources'] = this.isEditUserRootNodeTeamMember
          && this.canEditUserControlTenantConfig
          && this.purchaseResources;
        formData['Team.belongsto'] = this.belongsToTeam;
        formData['PaidService.run'] = this.usePaidServices;
        formData['NodeAndPod.archive'] = this.nodeandpodArchive;
      }

      const payload = {
        userId: this.getEditUser.id,
        permissions: formData,
        accessPointId: this.accessPointId,
      };

      const userStore = useUserStore();

      try {
        await userStore.savePermissions(payload);
        this.dialog = false;
        this.preventDoubleClick = false;
        this.$showMessage(this.$t('menus.userPermissions.permissionsUpdated'));

        this.refreshUsers();
      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message
        ) {
          this.apiError = error.response.data.error.message;
        } else {
          this.apiError = "Error!";
          console.log(error); // unhandled error
        }

        // Scroll to the bottom of the dialog body
        const cardBody = this.$refs.cardBody;
        this.$nextTick(() => {
          const element = cardBody.$el || cardBody;
          element.scrollTop = element.scrollHeight;
        });

        this.preventDoubleClick = false;
      }
    },
    updateControls: function(user) {
      let accessPoints = [];
      if (Array.isArray(user?.tenants)) {
        for (let i = 0; i < user.tenants.length; i++) {
          accessPoints = accessPoints.concat(user.tenants[i].accessPoints);
        }
      }

      const accessPoint = accessPoints.find((ap) => ap?.node?.id === this.accessPointId);
      const userAbilities = accessPoint?.group?.abilities || [];

      if (!userAbilities || Array.isArray(userAbilities) && userAbilities.length === 0) {
        return;
      }

      if (this.canShowUserPermissions) {
        this.userList = this.findAbility(userAbilities, 'list', 'User');
        this.userControl = this.findAbility(userAbilities, 'control', 'User');
      }

      if (this.isContextUserIsTeamMember) {
        this.tenantconfigControl = this.findAbility(userAbilities, 'control', 'TenantConfiguration');
        this.purchaseResources = this.findAbility(userAbilities, 'purchaseResources', 'TenantConfiguration');
        this.belongsToTeam = this.findAbility(userAbilities, 'belongsto', 'Team');
        this.nodeandpodArchive = this.findAbility(userAbilities, 'archive', "NodeAndPod");
        this.usePaidServices = this.findAbility(userAbilities, 'run', 'PaidService');
      }

      this.nodeandpodList = this.findAbility(userAbilities, 'list', "NodeAndPod");
      this.nodeandpodControl = this.findAbility(userAbilities, 'control', "NodeAndPod");
      this.nodeandpodDownload = this.findAbility(userAbilities, 'download', "NodeAndPod");
      this.nodeandpodDelete = this.findAbility(userAbilities, 'delete', "NodeAndPod");
      this.viewAnalytics = this.findAbility(userAbilities, 'viewAnalytics', 'NodeAndPod');
      this.podsLabel = this.findAbility(userAbilities, 'label', 'Pod');
      this.assetList = this.findAbility(userAbilities, 'list', "Asset");
      this.fileandassetUpload = this.findAbility(userAbilities, 'upload', "FileAndAsset");

      this.podserviceList = this.findAbility(userAbilities, 'list', "PodService");
      this.podserviceControl = this.findAbility(userAbilities, 'control', "PodService");
      this.useFreeServices = this.findAbility(userAbilities, 'run', 'FreeService');
      this.listShareLinks = this.findAbility(userAbilities, 'list', 'ShareLinks');
      this.controlShareLinks = this.findAbility(userAbilities, 'control', 'ShareLinks');
    },
    findAbility: function (abilities, action, subject) {
      for (let i = 0; i < abilities.length; i++) {
        if (abilities[i].action === action && abilities[i].subject === subject) {
          return true;
        }
      }
      return false;
    },
    openDialog(userCreated = false) {
      this.dialog = true;
      this.userCreated = userCreated;
    },
    closeDialog() {
      this.dialog = false;

      if (this.userCreated) {
        this.refreshUsers();
      }
    },
    refreshUsers() {
      const authStore = useAuthStore();
      const activeAccessPointId =  authStore.rootNodeId;

      const payload = { accessPointId: activeAccessPointId };

      const userStore = useUserStore();
      userStore.refreshUsers(payload);
    }
  },
  computed: {
    isCurrentUser: function () {
      const authStore = useAuthStore();
      const dbUser = authStore.dbUser;

      return this.getEditUser &&
          this.getEditUser.id &&
          this.getEditUser.id === dbUser.id;
    },
    userType: function() {
      const commonStore = useCommonStore();
      return commonStore.userType;
    },
    isFormDisabled: function() {
      return !this.getEditUser || this.isCurrentUser || this.preventDoubleClick;
    },
    activeTenantId: function() {
      const authStore = useAuthStore();
      return authStore.getActiveTenantId;
    },
    isContextUserIsTeamMember: function() {
      return this.$belongsToTeam(this.rootNodeId);
    },
    rootNodeId: function() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    accessPointName: function() {
      const nodeStore = useNodeStore();
      const accessPoint = nodeStore.getNodeById(this.accessPointId);
      return accessPoint?.name ?? '';
    },
    canShowUserPermissions: function() {
      return this.$canListUser() || this.$canControlUser();
    },
    isEditUserRootNodeTeamMember: function() {
      return this.rootNodeId === this.accessPointId && this.belongsToTeam;
    },
    canEditUserControlTenantConfig: function() {
      return this.tenantconfigControl;
    },
  }
}
</script>

<style>
</style>
